<template>
    <div class="rn-popup-modal share-modal-wrapper modal fade bg-dark/50" id="shareModal" tabindex="-1" aria-hidden="true">
        <button type="button" class="btn-close absolute top-4 right-4 bg-transparent border-0 text-white text-2xl hover:text-primary" data-bs-dismiss="modal" aria-label="Close"><i class="feather-x"/></button>
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content share-wrapper bg-[var(--background-color-1)] p-6 rounded-lg">
                <div class="modal-header share-area border-b border-[var(--color-border)] pb-4 mb-4">
                    <h5 class="modal-title text-lg font-semibold text-white">Share this NFT</h5>
                </div>
                <div class="modal-body">
                    <ul class="social-share-default flex flex-wrap gap-4">
                        <li><a href="#" class="flex items-center gap-2 text-gray-400 hover:text-primary transition-colors"><span class="icon"><i class="feather-facebook"/></span><span class="text">facebook</span></a></li>
                        <li><a href="#" class="flex items-center gap-2 text-gray-400 hover:text-primary transition-colors"><span class="icon"><i class="feather-twitter"/></span><span class="text">twitter</span></a></li>
                        <li><a href="#" class="flex items-center gap-2 text-gray-400 hover:text-primary transition-colors"><span class="icon"><i class="feather-linkedin"/></span><span class="text">linkedin</span></a></li>
                        <li><a href="#" class="flex items-center gap-2 text-gray-400 hover:text-primary transition-colors"><span class="icon"><i class="feather-instagram"/></span><span class="text">instagram</span></a></li>
                        <li><a href="#" class="flex items-center gap-2 text-gray-400 hover:text-primary transition-colors"><span class="icon"><i class="feather-youtube"/></span><span class="text">youtube</span></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShareModal'
    }
</script>